// Renderiza UMA caixa-d’água
import tanqueImg from "../../../../assets/img/CaixaDagua.png";
import "./renderCaixa.css";

export default function RenderCaixa({ desc, niveis = {} }) {
  // se algum campo faltar, assume false
  const {
    extravasao = false,
    normal     = false,
    baixo      = false,
  } = niveis;

  return (
    <div className="card">
      <div className="tankWrapper">
        <img src={tanqueImg} alt={desc} className="tankImg" />

        <div className={`level ${extravasao ? "alto"   : ""}`}>Extravasão</div>
        <div className={`level ${normal     ? "normal" : ""}`}>Normal</div>
        <div className={`level ${baixo      ? "baixo"  : ""}`}>Baixo</div>
      </div>

      <h2 className="caption">{desc}</h2>
    </div>
  );
}
